export default __webpack_public_path__ + "static/media/tools_black.00b62dd6.svg";